import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router";
import { Translate, withLocalize } from 'react-localize-redux';
import { layoutActions } from '../../store/layoutStore';
import { userContextActions } from '../../store/userContextStore';
import SettingsMenu from './settingsMenu';

import PerfectScrollbar from 'react-perfect-scrollbar';
import PopupFilledHeader from '../layoutItems/popupFilledHeader';
import DisplaySettings from './displaySettings';

import './settings.scss';

class SettingsDockerMenu extends Component {
    state = {
        tab: "general"
    }

    timer = null;

    componentDidUpdate(prevProps) {
        if (prevProps.layout.isSettingsMenuToggled !== this.props.layout.isSettingsMenuToggled) {
            clearTimeout(this.timer);
            if (!this.props.isToggled)
                this.timer = setTimeout(() => this.setState({ tab: "general" }), 500);
        }
    }

    render() {
        return (<>
            <SettingsMenu isToggled={this.props.layout.isSettingsMenuToggled} hideDockedMenu={this.props.toggleSettingsMenu} scrollWidth={this.props.scrollWidth}>
                <div className="popup-filled-header-settings">
                    <PopupFilledHeader title={this.props.translate('Settings.Display.Heading')} close={() => this.props.toggleSettingsMenu()} />
                    <div className={classnames('tabs tabs-subheader', { 'tinted': true, 'popup-filled-tabs': true })}>
                        <ul style={{ border: "none" }}>
                            <li className={`tab-link ${this.state.tab === "general" ? 'is-active' : ''}`}>
                                <a onClick={() => this.onTabChange("general")}>
                                    <Translate id='Search.Settings.Tab.General' />
                                </a>
                                <div className="search-progress-short" style={{ display: this.state.tab === "general" ? "" : "none" }}></div>
                            </li>
                            <li className={`tab-link ${this.state.tab === "style" ? 'is-active' : ''}`}>
                                <a onClick={() => this.onTabChange("style")}>
                                    <Translate id='Search.Settings.Tab.Appearance' />
                                </a>
                                <div className="search-progress-short" style={{ display: this.state.tab === "style" ? "" : "none" }}></div>
                            </li>
                        </ul>
                    </div>
                </div>
                <PerfectScrollbar>

                    <div className='panel-block settings'>
                        <DisplaySettings isToggled={this.props.layout.isSettingsMenuToggled} tab={this.state.tab} />

                    </div>
                </PerfectScrollbar>
            </SettingsMenu>
        </>);
    }

    onTabChange(value) {
        this.setState({ tab: value });
    }
}
export default withLocalize(connect(
    state => ({ layout: state.layout, user: state.userContext }),
    dispatch => bindActionCreators({ ...layoutActions, ...userContextActions }, dispatch)
)(withRouter(SettingsDockerMenu)));